export default __webpack_public_path__ + "static/media/instyle-box2.b31370da.png";